import { render } from "./404Page.vue?vue&type=template&id=2bac0116&scoped=true"
import script from "./404Page.vue?vue&type=script&lang=js"
export * from "./404Page.vue?vue&type=script&lang=js"

import "./404Page.vue?vue&type=style&index=0&id=2bac0116&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bac0116"]])

export default __exports__